import HTTPError from '../../lib/errors/http-error';
import api from '../../lib/http';

export default {
  getTournaments: async () => {
    const response = await api(
      'get',
      'tournaments/',
      false,
      false,
      true,
    );

    if (!response.ok) {
      throw new HTTPError(response.status, response.data);
    }

    return response;
  },
};
